import http from './http';

export default {
  checkNameAvailability(payload) {
    return http.post('/ajax/check-name-availability', payload);
  },
  checkNameInformation(payload) {
    return http.post('/ajax/check-name-information', payload);
  },
  submitAskForm(payload) {
    return http.post('/ajax/ask-form', payload);
  },
  submitDownloadGuideLLC(payload) {
    return http.post('/ajax/download-guide-llc', payload);
  },
  submitDownloadGuideTypesAndEntities(payload) {
    return http.post('/ajax/download-guide-types-and-entities', payload);
  },
};
